import React from "react";

// components
import PageTitle from "../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import checkToken from "../services/checkToken";
import getDdt from "../services/getDdt";
import editDdt from "../services/editDdt";
import { Stack } from "@mui/system";
import { MenuItem, TextField } from "@material-ui/core";
import LoadingButton from "@mui/lab/LoadingButton";
import _default from "../themes/default";
import SettingsTitle from "../widgets/SettingsTitle";
import ManageRowSettings from "../widgets/ManageRowSettings";
import editDdtPdf from "../services/editDdtPdf";
import Loading from "../components/Loading";
import getClienti from "../services/getClienti";
import getCliente from "../services/getCliente";

const cookies = new Cookies();
let username = cookies.get('username', { path: '/' });
let token = cookies.get('token', { path: '/' });

export default class EditDdt extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            id: '',
            isLoading: true,
            cliente: '',
            rif: '',
            indirizzo: '',
            citta: '',
            causale: '',
            destinazione: '',
            trasporto: '',
            vettore: '',
            annotazioni: '',
            data_ritiro: '',
            link_ddt: '',
            ddt_pdf: '',
            p_iva: '',
            prodotti: [],
            id_ordine: 0,
            clienti: [],
            conferma_magazzino: 0,
            conferma: 0
        };
    }

    async save() {
        this.setState({ isLoading: true });

        if (!this.state.causale) {
            alert('Per favore, inserisci la causale.');
            return;
        }

        if (!this.state.destinazione) {
            alert('Per favore, inserisci la destinazione.');
            return;
        }

        if (!this.state.trasporto) {
            alert('Per favore, inserisci il trasporto.');
            return;
        }

        if (!this.state.vettore) {
            alert('Per favore, inserisci il vettore.');
            return;
        }

        if (!this.state.annotazioni) {
            alert('Per favore, inserisci le annotazioni.');
            return;
        }

        if (!this.state.data_ritiro) {
            alert('Per favore, inserisci la data di ritiro.');
            return;
        }

        if (this.state.prodotti.length === 0) {
            alert('Inserire un prodotto');
            return;
        }

        for (let i = 0; i < this.state.prodotti.length; i++) {
            if (!this.state.prodotti[i].quantita || !this.state.prodotti[i].label) {
                alert('Per favore, compila tutti i campi del prodotto.');
                return;
            }
        }

        let ddt = {
            id: this.state.id,
            cliente: this.state.cliente,
            rif: this.state.rif,
            indirizzo: this.state.indirizzo,
            citta: this.state.citta,
            causale: this.state.causale,
            destinazione: this.state.destinazione,
            trasporto: this.state.trasporto,
            vettore: this.state.vettore,
            annotazioni: this.state.annotazioni,
            data_ritiro: this.state.data_ritiro,
            p_iva: this.state.p_iva,
            prodotti: JSON.stringify(this.state.prodotti)
        };

        let res = await editDdt(username, token, ddt);
        if (res.result === 'ok') {
            window.location.href = '#/service/ddt';
            return;
        }

        this.setState({ isLoading: false });
        alert('Si è verificato un errore durante l\'aggiornamento del cliente. Per favore, riprova.');
    }

    addInput(param) {
        let obj = { label: '', quantita: null }
        let new_array = [...this.state[param], obj]
        this.setState({ [param]: new_array })
    }

    async loadCliente(id) {
        let cliente_selezionato = await getCliente(username, token, id);

        this.setState({
            p_iva: cliente_selezionato.p_iva,
            indirizzo: cliente_selezionato.indirizzo,
            citta: cliente_selezionato.citta,
        })
    }

    async onChangePdfDdt(username, token, base64_payload, rif, id_ddt) {
        const res = await editDdtPdf(username, token, base64_payload, rif, id_ddt);
        if (res.result === "ok") {
            this.setState({ ddt_pdf: res.link });
        }
    }

    reload = async () => {
        this.setState({ isLoading: true });
        username = cookies.get('username', { path: '/' });
        token = cookies.get('token', { path: '/' });
        const check = await checkToken(username, token, true);
        const type = parseInt(check.utente.tipo);
        let current = cookies.get('ddt', { path: '/' });

        if (!current) {
            window.location.href = '#/service/ddt';
            return;
        }

        const clienti = await getClienti(username, token);
        const ddt = await getDdt(username, token, current);
        clienti.forEach((c, i) => {
            clienti[i].label = c.ragione_sociale
        })


        this.setState({
            id: current,
            type,
            cliente: ddt.cliente,
            rif: ddt.rif,
            indirizzo: ddt.indirizzo,
            citta: ddt.citta,
            causale: ddt.causale,
            destinazione: ddt.destinazione,
            trasporto: ddt.trasporto,
            vettore: ddt.vettore,
            annotazioni: ddt.annotazioni,
            data_ritiro: ddt.data_ritiro,
            link_ddt: ddt.link_ddt,
            ddt_pdf: ddt.ddt_pdf,
            p_iva: ddt.p_iva,
            prodotti: JSON.parse(ddt.prodotti),
            id_ordine: parseInt(ddt.id_ordine),
            clienti: clienti,
            conferma_magazzino: ddt.conferma_magazzino === 1,
            conferma: ddt.conferma === 1
        });
        this.setState({ isLoading: false });
    }

    componentDidMount() {
        this.reload();
    }

    render() {
        if (this.state.isLoading)
            return <Loading />;

        return (
            <>
                <PageTitle title={'Modifica ddt ' + this.state.rif} />
                <Stack>
                    <TextField
                        select
                        label="Cliente"
                        value={this.state.cliente}
                        onChange={(e) => {
                            this.setState({ cliente: e.target.value });
                            this.loadCliente(e.target.value);
                        }}
                    >
                        {
                            this.state.clienti.map((cliente_map, i) => {
                                return (
                                    <MenuItem key={i + cliente_map.id} value={cliente_map.id}>{cliente_map.label}</MenuItem>
                                )
                            })
                        }
                    </TextField>
                </Stack>
                <Stack
                    spacing={3}
                    direction="row"
                    sx={{ flex: 1, marginTop: 5 }}
                >
                    <TextField
                        fullWidth
                        variant="outlined"
                        label="Partita IVA"
                        value={this.state.p_iva}
                        onChange={(e) => {
                            this.setState({ p_iva: e.target.value });
                        }}
                    />
                    <TextField
                        fullWidth
                        label="Rif"
                        variant="outlined"
                        value={this.state.rif}
                        onChange={(e) => {
                            this.setState({ rif: e.target.value });
                        }}
                    />
                </Stack>
                <Stack
                    spacing={3}
                    direction="row"
                    sx={{ flex: 1, marginTop: 5 }}
                >
                    <TextField
                        fullWidth
                        label="Indirizzo"
                        variant="outlined"
                        value={this.state.indirizzo}
                        onChange={(e) => {
                            this.setState({ indirizzo: e.target.value });
                        }}
                    />
                    <TextField
                        fullWidth
                        label="Città"
                        variant="outlined"
                        value={this.state.citta}
                        onChange={(e) => {
                            this.setState({ citta: e.target.value });
                        }}
                    />
                </Stack>

                <Stack spacing={3} sx={{ flex: 1 }}>
                    <div style={rowTitle}>
                        <SettingsTitle title="Prodotti" />
                        <img src={require('../images/add.png')} alt="" style={{ cursor: 'pointer', width: 20, height: 20, alignSelf: 'flex-end' }} onClick={() => this.addInput('prodotti')} />
                    </div>
                    <div>
                        {
                            this.state.prodotti.map((el, i) => {
                                return (
                                    <div key={i} style={groupInput}>
                                        <Stack direction={"row"} spacing={1} sx={{ flex: 1 }} >
                                            <TextField
                                                fullWidth
                                                value={el.label}
                                                label="Prodotto"
                                                onChange={(e) => {
                                                    let arr = [...this.state.prodotti]
                                                    arr[i].label = e.target.value;
                                                    arr[i].quantita = 1;
                                                    this.setState({ prodotti: arr })
                                                }}
                                            />
                                            <TextField
                                                InputLabelProps={{ shrink: el.quantita }}
                                                type="number"
                                                variant="outlined"
                                                label={'Quantita'} value={el.quantita}
                                                onChange={(e) => {
                                                    let arr = this.state.prodotti
                                                    arr[i].quantita = e.target.value
                                                    this.setState({ prodotti: arr })
                                                }}
                                            />
                                            <ManageRowSettings
                                                callback={() => {
                                                    let updated = this.state.prodotti.filter((e, index) => index !== i)
                                                    this.setState({ prodotti: updated })
                                                }}
                                            />
                                        </Stack>
                                    </div>
                                )
                            })
                        }
                    </div>
                </Stack>

                <Stack
                    spacing={3}
                    direction="row"
                    sx={{ flex: 1, marginTop: 5 }}
                >
                    <TextField
                        variant="outlined"
                        fullWidth
                        label="Causale"
                        value={this.state.causale}
                        onChange={(e) => {
                            this.setState({ causale: e.target.value });
                        }}
                    />
                    <TextField
                        variant="outlined"
                        fullWidth
                        label="Destinazione"
                        value={this.state.destinazione}
                        onChange={(e) => {
                            this.setState({ destinazione: e.target.value });
                        }}
                    />
                </Stack>
                <Stack
                    spacing={3}
                    direction="row"
                    sx={{ flex: 1, marginTop: 5 }}
                >
                    <TextField
                        select
                        variant="outlined"
                        fullWidth
                        label="Trasporto"
                        value={this.state.trasporto}
                        onChange={(e) => {
                            this.setState({ trasporto: e.target.value });
                        }}
                    >
                        <MenuItem value="mittente">Mittente</MenuItem>
                        <MenuItem value="vettore">Vettore</MenuItem>
                        <MenuItem value="destinatario">Destinatario</MenuItem>
                    </TextField>
                    <TextField
                        variant="outlined"
                        fullWidth
                        label="Vettore"
                        value={this.state.vettore}
                        onChange={(e) => {
                            this.setState({ vettore: e.target.value });
                        }}
                    />
                </Stack>
                <Stack
                    spacing={3}
                    direction="row"
                    sx={{ flex: 1, marginTop: 5 }}
                >
                    <TextField
                        variant="outlined"
                        fullWidth
                        label="Annotazioni"
                        value={this.state.annotazioni}
                        onChange={(e) => {
                            this.setState({ annotazioni: e.target.value });
                        }}
                    />
                    <TextField
                        variant="outlined"
                        fullWidth
                        label="Data Ritiro"
                        value={this.state.data_ritiro}
                        onChange={(e) => {
                            this.setState({ data_ritiro: e.target.value });
                        }}
                    />
                </Stack>

                <Stack
                    spacing={3}
                    direction="row"
                    sx={{ flex: 1, marginTop: 5 }}
                >
                    {!this.state.ddt_pdf && this.state.conferma_magazzino && <TextField
                        label="Carica Ddt Firmato"
                        type="file"
                        variant="outlined"
                        InputLabelProps={{ shrink: true }}
                        onChange={(e) => {
                            let file = e.target.files[0];
                            let reader = new FileReader();
                            reader.readAsDataURL(file);
                            reader.onload = () => {
                                this.setState({ pdfDdt: reader.result });
                                this.onChangePdfDdt(username, token, this.state.pdfDdt, this.state.rif, this.state.id);
                            };
                            reader.onerror = function (error) {
                                console.log('Error: ', error);
                            };
                        }}
                    />}

                    {this.state.ddt_pdf && <LoadingButton
                        variant="contained"
                        onClick={() => { window.open(this.state.ddt_pdf, '_blank'); }}
                        sx={{ height: 50 }}
                    >
                        Visualizza documento di trasporto
                    </LoadingButton>}

                </Stack>

                {!this.state.ddt_pdf && <Stack
                    spacing={3}
                    direction="row"
                    sx={{ flex: 1, marginTop: 5 }}
                >
                    <LoadingButton
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            this.save();
                        }}
                        fullWidth sx={{ flex: 1, minHeight: 50 }}
                        style={{ backgroundColor: _default.palette.primary.main }}
                    >
                        Salva Modifiche e genera nuovo DDT
                    </LoadingButton>
                    <LoadingButton
                        variant="contained"
                        fullWidth sx={{ flex: 1, minHeight: 50 }}
                        onClick={() => {
                            window.open(this.state.link_ddt, '_blank');
                        }}
                    >
                        Visualizza DDT
                    </LoadingButton>
                </Stack>}
            </>
        );
    }
}

const rowTitle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingBottom: 4,
    borderBottom: '0.3px solid #c1c1c1',
    marginTop: 30,
    marginBottom: 20
}

const groupInput = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 5
}
